export default __webpack_public_path__ + "static/media/Login_img.8fdd5541.svg";